import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import routes from '../routes'

import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'

const AppBreadcrumb = () => {
  const basePath = String(process.env.PUBLIC_URL).trim()
  const currentLocation = useLocation().pathname
  const search = useLocation().state?.search
  const history = useHistory()
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [breadcrumbs_raiz, setBreadcrumbsRaiz] = useState([])

  const getRouteName = (pathname, routes) => {
    let currentRoute = routes.find((route) => route.to === pathname)
    if (currentRoute === undefined) {
      if (pathname.search('/ps/') !== -1) {
        currentRoute = routes.find((route) => route.to === pathname.replace('/ps/', '/pf/'))
      } else {
        currentRoute = routes.find((route) => route.to === pathname.replace('/pf/', '/ps/'))
      }
    }
    return currentRoute?.name
  }

  const getRoutePath = (pathname, routes) => {
    let currentRoute = routes.find((route) => route.to === pathname)
    if (currentRoute === undefined) {
      if (pathname.search('/ps/') !== -1) {
        currentRoute = routes.find((route) => route.to === pathname.replace('/ps/', '/pf/'))
      } else {
        currentRoute = routes.find((route) => route.to === pathname.replace('/pf/', '/ps/'))
      }
    }
    if (pathname === basePath + '/pf/buscador') {
      return currentRoute?.to + '/tramites'
    } else {
      return currentRoute?.to
    }
  }

  const getBreadcrumbs = (location) => {
    const _breadcrumbs = []
    if (location.search('noticias') >= 0) {
      _breadcrumbs.push({
        pathname: `${basePath}/noticias`,
        name: 'Noticias',
        active: location.search('noticias/') < 0,
        search: search,
      })
    } else {
      if (routes.find((route) => route.to === location) !== undefined) {
        var _location = location.replace(basePath, '')
        _location.split('/').reduce((prev, curr, index, array) => {
          const currentPathname = `${prev}/${curr}`
          if (currentPathname !== '/ps' && currentPathname !== '/pf') {
            _breadcrumbs.push({
              pathname: getRoutePath(basePath + currentPathname, routes),
              name: getRouteName(basePath + currentPathname, routes),
              active: index + 1 === array.length ? true : false,
              search: search,
            })
          }
          return currentPathname
        })
      }
    }
    return _breadcrumbs
  }

  const llamada = (_path, _search) => {
    if (_path.includes('/ps/buscador/tramites')) {
      history.push({
        pathname: _path,
        search: 'd=' + _search,
      })
    } else {
      history.push({
        pathname: _path,
        state: {
          search: _search,
        },
      })
    }
  }

  useEffect(() => {
    setBreadcrumbs(getBreadcrumbs(currentLocation))
    setBreadcrumbsRaiz(getBreadcrumbs(basePath + '/inicio')[0])
  }, [currentLocation])

  return (
    <CBreadcrumb className="m-0">
      {currentLocation === breadcrumbs_raiz.pathname ? (
        ''
      ) : (
        <CBreadcrumbItem href={breadcrumbs_raiz.pathname} key={0}>
          {breadcrumbs_raiz.name}
        </CBreadcrumbItem>
      )}
      {breadcrumbs.map((breadcrumb, index) => {
        return (
          <CBreadcrumbItem
            {...(breadcrumb.active ? { active: true } : { className: 'cursor-pointer' })}
            onClick={() => {
              llamada(breadcrumb.pathname, breadcrumb.search)
            }}
            key={index + 1}
          >
            {breadcrumb.name}
          </CBreadcrumbItem>
        )
      })}
    </CBreadcrumb>
  )
}

export default React.memo(AppBreadcrumb)
